<template>
  <div>
    <nav-bar/>
    <div class="container">
      <div class="row page-padding" v-if="isContentLoaded">
        <div class="col-12">
          <v-img :src="$replaceHttps(details.FileUrl)" max-height="400" contain></v-img>
        </div>
        <div class="col-12">
          <div class="row align-items-center">
            <div class="col-12 primary-text font18px ">{{ details.Name }}</div>
            <!--              <div class="col-2 primary-text font16px">تاریخ:</div>-->
            <!--              <div class="col-10 black&#45;&#45;text"-->
            <!--                   >{{$convertDate(details.ModifiedDate)}}</div>-->
            <!--              <div class="col-3 primary-text font16px">تعداد بازدید:</div>-->
            <!--              <div class="col-9 black&#45;&#45;text"-->
            <!--              >{{details.CountVisit}}</div>-->
            <!--              <div v-if="details.Description !== null" class="col-2 primary-text font16px">توضیحات:</div>-->
            <div class="col-12 black--text" v-if="details.Description !== null"
                 v-html="details.Description"></div>
            <div class="col-12 black--text" v-if="details.AttachmentFileUrl">
              <a :href="details.AttachmentFileUrl" target="_blank">
                <v-btn color="primary" elevation="0">
                  مشاهده فایل ضمیمه
                </v-btn>
              </a>
            </div>
          </div>
        </div>
        <div v-if="details.AparatLink !== null && details.AparatLink !== 'null'" class="col-12" v-html="details.AparatLink"></div>

      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";

export default {
  name: "knowledgeBaseDetail",
  components: {NavBar},
  metaInfo() {
    return {
      title: 'ادمین-' + this.details.Name
    }
  },

  data: () => ({
    details: {},
    isContentLoaded: false,
    showLoaderDialog: false,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetKnowledgeDetail?knowledgeId=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            this.details = JSON.parse(result)
            this.isContentLoaded = true
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>